export function userService($http: ng.IHttpService, MyConstant, $mdDialog: ng.material.IDialogService, $window: ng.IWindowService) {
    "ngInject"
    let user;
    this.getInfo = function () {
        return $http.get(`${MyConstant.ApiUrl}Auth/GetAbstractUserInfo`, { cache: true })

    }

    this.getProfile = () => {
        return $http.get(`${MyConstant.ApiUrl}Profile/GetProfile`)
    }
    
    this.showLogin = function () {
        $mdDialog.show(
            $mdDialog.login()
        )
    }

    this.register = (user) => {
        return $http.post(`${MyConstant.ApiUrl}Auth/AddDnnUser`, user)
    }

    this.registerAndComplete = (user) => {
        return $http.post(`${MyConstant.ApiUrl}UserManagement/RegisterViaWeb`, user)
    }

    this.login = (user) => {
        return $http.post(`${MyConstant.ApiUrl}UserManagement/LoginViaWeb`, user)
    }

    this.loginViaGoogle = (returnUrl = '/') => {
        let url = `${MyConstant.ApiUrl}UserManagement/LoginViaGoogle?returnUrl=${returnUrl}`
        $window.location.href = url
    }
}


// WEBPACK FOOTER //
// ./src/services/user/user.ts